(function () {
  "use strict";

  var form = document.getElementById("pdpForm");
  if (!form) return;

  var productJsonScript = document.getElementById("pdpProductJson");
  var product = null;
  try {
    product = productJsonScript ? JSON.parse(productJsonScript.textContent) : null;
  } catch (e) {
    product = null;
  }

  var selects = Array.prototype.slice.call(form.querySelectorAll(".pdp-option-select"));
  var variantIdInput = document.getElementById("pdpVariantId");
  var priceEl = document.getElementById("pdpPrice");
  var submitBtn = form.querySelector('button[type="submit"]');

  function formatMoney(cents) {
    return "£" + (cents / 100).toFixed(2);
  }

  function currentSelection() {
    return selects.map(function (s) { return s.value; });
  }

  function findVariant(selection) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    }) || null;
  }

  // When a colour + size combination doesn't exist, pick the closest real variant
  // that keeps the option the shopper just changed, so the bag never gets the wrong item.
  function closestVariant(selection, changedIndex) {
    if (!product) return null;
    var best = null, bestScore = -1;
    product.variants.forEach(function (v) {
      if (changedIndex > -1 && v.options[changedIndex] !== selection[changedIndex]) return;
      var score = 0;
      v.options.forEach(function (opt, i) { if (opt === selection[i]) score += 2; });
      if (v.available) score += 1;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  function setUnavailable() {
    if (variantIdInput) variantIdInput.value = "";
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Unavailable — choose another option";
    }
  }

  function applyVariant(variant) {
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? "Add to bag — " + formatMoney(variant.price)
        : "Sold out";
    }
    var img = variant.featured_image && variant.featured_image.src;
    var mainImg = document.getElementById("pdpMainImage");
    if (img && mainImg) mainImg.src = img + (img.indexOf("?") > -1 ? "&" : "?") + "width=800";
  }

  function onChange(e) {
    var selection = currentSelection();
    var variant = findVariant(selection);
    if (!variant) {
      var changedIndex = selects.indexOf(e && e.target);
      variant = closestVariant(selection, changedIndex);
      if (variant) {
        variant.options.forEach(function (opt, i) { if (selects[i]) selects[i].value = opt; });
      }
    }
    if (!variant) { setUnavailable(); return; }
    applyVariant(variant);
  }

  selects.forEach(function (s) { s.addEventListener("change", onChange); });

  // Safety net: never submit without a valid variant id
  form.addEventListener("submit", function (e) {
    if (variantIdInput && !variantIdInput.value) e.preventDefault();
  });

  var thumbs = document.querySelectorAll(".pdp-thumb");
  var mainImage = document.getElementById("pdpMainImage");
  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      var full = t.getAttribute("data-full");
      if (full && mainImage) mainImage.src = full;
    });
  });
})();
